export const GET_INQUIRIES = "GET_INQUIRIES";
export const GET_INQUIRY_BY_ID = "GET_INQUIRY_BY_ID";
export const UPDATE_INQUIRY = "UPDATE_INQUIRY";
export const DELETE_INQUIRY = "DELETE_INQUIRY";
export const CREATE_INQUIRY = "CREATE_INQUIRY";
